import Grid from '@material-ui/core/Grid';
import { memo, ReactElement } from 'react';
import { useFormContext } from 'react-hook-form';

import DateRangePicker from '~/ui/components/inputs/DateRangePicker';
import Select from '~/ui/components/inputs/SelectWithoutAnimation';
import { red } from '~/ui/constants/colors';
import { dateSortingOptions } from '~/ui/constants/sortingOptions';

const ClientAllocationFilters = (): ReactElement => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Grid container spacing={1}>
      <Grid item sm={2}>
        <Select
          label="Sort By"
          control={control}
          name="sorting"
          errors={errors}
          options={dateSortingOptions}
          color={red}
          hideSelectedOptions={false}
        />
      </Grid>
      <Grid item sm={4}>
        <DateRangePicker
          label="Select Date Range"
          control={control}
          name="dateRange"
          errors={errors}
        />
      </Grid>
    </Grid>
  );
};

export default memo(ClientAllocationFilters);
